module.exports = "<div>{{ ::vm.receiver.name }}</div> <div>{{ ::vm.receiver.streetName }} {{ ::vm.receiver.houseNumber }} {{ ::vm.receiver.boxNumber }}</div> <div>{{ ::vm.receiver.postalCode }} {{ ::vm.receiver.cityName }}</div> <div class=type-xsmall>Vergunningsnr. {{ ::vm.receiver.licenseNumber }}, klantnr. {{ ::vm.receiver.customerNumber }}</div>";


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/components/order-receiver-detail.html
// module id = 531
// module chunks = 0